import React from 'react';
import '../../../css/Dimmer.css';

/**
 * A component that dims the whole screen.
 */
const Dimmer = () => /*#__PURE__*/React.createElement("div", {
  "data-testid": "dimmer",
  className: "dimmer"
});
export default Dimmer;